/**
 * Generated Version Information
 * DO NOT EDIT - This file is auto-generated by scripts/generate-version.ts
 */

export const VERSION = {
  appName: "optlab",
  env: "dev",
  gitSha: "da1b6fe",
  buildTime: "2026-02-02T22:36:42.509Z",
} as const;
